<div class="row">
  <div class="col-md-6">
    <div class="search">
      <cpq-input #availableGroupsInput [label]="{key: labelAvailable.key, placeholder: labelAvailable.placeholder}" #searchAvailableItems="ngModel" [name]="'searchAvailableItems'" [(ngModel)]='searchKeywordAvailable'
      (ngModelChange)="searchAvailable()" (focusout)="hasAvailableSearchResults=true"></cpq-input>
      @if (showSearchIconAvailable) {
        <span class="sap-icon search-icon"></span>
      } @else {
        <span class="sap-icon close-icon" (click)="emptyInputField(false)"></span>
      }
      @if (!hasAvailableSearchResults) {
        <ul class="no-results">
          <li>
            {{'Admin.Msg.NoResultsSearch' | translate}}
          </li>
        </ul>
      }
    </div>

    <div class="title">
      @if (available && available.length > 0) {
        <a (click)="expandCollapseAllAvailableGroups(false)">
          {{'Admin.SelectList.ExpandAll' | translate}}
        </a>
      }
      <span class="line-separator">|</span>
      @if (available && available.length > 0) {
        <a (click)="expandCollapseAllAvailableGroups(true)">
          {{'CategorySelector.CollapseAll' | translate}}
        </a>
      }
      @if (available && available.length > 0) {
        <a class="float-right" (click)="addAllAvailableGroups()"> {{'Admin.SelectList.AddAll' | translate}} </a>
      }
    </div>

    <div class="list">
      <ul class="main-list">
        @for (group of filteredAvailableItems; track group) {
          @if (group && (group.isVisible) || (group.id === PermissionType.Users && isCpqPermissions)) {
            <li>
              <div class="text-container">
                <span class="main-item" (click)="group.isCollapsed = !group.isCollapsed" [ngClass]="{'rotate': !group.isCollapsed}">
                  <span class="sap-icon">&#xe1e2;</span>
                  <span>{{group.name}}</span>
                </span>
                @if (group.id !== PermissionType.Users) {
                  <span class="add-all" (click)="addAllChildItemsToSelected(group.id)">
                    {{'Admin.SelectList.AddAll' | translate}}
                    <span class="sap-icon">&#xe04c;</span>
                  </span>
                }
              </div>
              @if (!isCpqPermissions) {
                @if (group.children) {
                  <ul>
                    @for (child of group.children; track child) {
                      @if (child.isVisible) {
                        <li #listItem [ngClass]="{'expanded' : !group.isCollapsed}" class="child-item">
                          <div class="text-container" (click)="addSelectedInteractive(child, listItem)" >
                            {{child.name}}
                            <div class="arrow-container">
                              <span class="sap-icon">&#xe04c;</span>
                            </div>
                          </div>
                        </li>
                      }
                    }
                  </ul>
                }
              }
              <!--cpq permissions -->
              @if (isCpqPermissions) {
                @if (group.children && group.id !== PermissionType.Users) {
                  <ul>
                    <cdk-virtual-scroll-viewport [id]="group.id" [itemSize]="availableItemHeight" [minBufferPx]="availableItemsContainerMaxHeight"
                      [maxBufferPx]="availableItemsContainerMaxHeight" [ngClass]="{'expanded' : !group.isCollapsed}"
                      [ngStyle]="{'height': group.children.length <= 9 ? group.children.length * availableItemHeight + 'px' : availableItemsContainerMaxHeight + 'px'}" class="cpq-scroll">
                      <ng-container *cdkVirtualFor="let child of group.children" >
                        @if (child.isVisible) {
                          <li #listItem [ngClass]="{'expanded' : !group.isCollapsed }" class="child-item">
                            <div class="text-container" (click)="addSelectedInteractive(child, listItem)"  id="{{group.name}}_{{child.name}}">
                              {{child.name}}
                              <div class="arrow-container">
                                <span class="sap-icon">&#xe04c;</span>
                              </div>
                            </div>
                          </li>
                        }
                      </ng-container>
                    </cdk-virtual-scroll-viewport>
                  </ul>
                }
                <!-- users -->
                @if (group.id === PermissionType.Users) {
                  <div>
                    <li [ngClass]="{'expanded' : !group.isCollapsed, 'child-item': group.isCollapsed}" class="permission-users">
                      <div class="users" [ngClass]="{'expanded' : !group.isCollapsed, 'child-item': group.isCollapsed}">
                        <cpq-select class="top-margin-fix" name="user" [type]="SelectType.AsyncSearchable" [url]="'lookups/user'" [label]="{placeholder: 'Admin.deflusersetup.PlaceholderForSelectUser'}"
                          [(ngModel)]="userId" (selectedItemText)='userSelected($event)'>
                        </cpq-select>
                      </div>
                    </li>
                  </div>
                }
              }
            </li>
          }
        }
      </ul>
    </div>

  </div>
  <div class="col-md-6">
    <div class="search">
      <cpq-input #selectedGroupsInput [label]="{key: labelSelected.key, placeholder: labelSelected.placeholder}" #searchSelectedItems="ngModel" [name]="'searchSelectedItems'" [(ngModel)]='searchKeywordSelected'
      (ngModelChange)="searchSelected()" (focusout)="hasSelectedSearchResults=true"></cpq-input>
      @if (showSearchIconSelected) {
        <span class="sap-icon search-icon"></span>
      } @else {
        <span class="sap-icon close-icon" (click)="emptyInputField(true)"></span>
      }
      @if (!hasSelectedSearchResults) {
        <ul class="no-results">
          <li>
            {{'Admin.Msg.NoResultsSearch' | translate}}
          </li>
        </ul>
      }
    </div>
    @if (selected && selected.length > 0) {
      <div class="text-right">
        <a (click)="removeAllSelected()" id="clearAll">
          {{'Admin.SelectList.ClearAll' | translate}}
        </a>
      </div>
    }
    <div class="list">
      <ul class="selected-list" [class.selected-list-border]="selected && filteredSelectedItems.length">
        @if (!filteredSelectedItems.length) {
          <li class="msg">
            <div class="alert alert-info">
              <span class="sap-icon">&#xe202;</span>
              <div class="content">
                {{emptySelectedListKey | translate}}
              </div>
            </div>
          </li>
        }
        @if (filteredSelectedItems.length) {
          <cdk-virtual-scroll-viewport id="selectedItems" [itemSize]="selectedItemHeight"
            [minBufferPx]="selectedItemsContainerMaxHeight" [maxBufferPx]="selectedItemsContainerMaxHeight"
            [ngStyle]="{'height': filteredSelectedItems.length <= 12 ? filteredSelectedItems.length * selectedItemHeight + 'px' : selectedItemsContainerMaxHeight + 'px'}"
            [ngClass]="{'expanded' : filteredSelectedItems.length}" class="cpq-scroll">
            <ng-container *cdkVirtualFor="let item of filteredSelectedItems">
              <li #selectedItem class="selectedItem" [class.disabled]="item.isDisabled" >
                <div class="flex">
                  <span class="item-name" [attr.title]="item.name">{{item.name}}</span>
                  @if (item.additionalInfo && item.additionalInfo.length > 0) {
                    <div class="error-text-color">
                      <span class="sap-icon">&#xe1f7;</span>
                      <span>{{item.additionalInfo}}</span>
                    </div>
                  }
                  @if (!item.isDisabled) {
                    <span class="sap-icon remove-icon" (click)="removeSelectedInteractive(item, selectedItem)"
                    title="{{'Admin.Msg.RemoveButton' | translate}}">&#xe03e;</span>
                  }
                </div>
              </li>
            </ng-container>
          </cdk-virtual-scroll-viewport>
        }
      </ul>
    </div>
  </div>
</div>